"use client";

import { Zap, Code2, LayoutTemplate, Gauge } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function WebAppsPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.webApps.title"
      description={serviceSummary("web-apps")}
    />
    <ServicePage
      labelKey="service.web.label"
      titleKey="service.web.title"
      descriptionKey="service.web.description"
      benefits={[
        {
          icon: Zap,
          titleKey: "service.web.benefit1.title",
          descKey: "service.web.benefit1.desc",
        },
        {
          icon: Code2,
          titleKey: "service.web.benefit2.title",
          descKey: "service.web.benefit2.desc",
        },
        {
          icon: LayoutTemplate,
          titleKey: "service.web.benefit3.title",
          descKey: "service.web.benefit3.desc",
        },
        {
          icon: Gauge,
          titleKey: "service.web.benefit4.title",
          descKey: "service.web.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.web.usecase1",
        "service.web.usecase2",
        "service.web.usecase3",
        "service.web.usecase4",
      ]}
      stack={[
        "Next.js",
        "React",
        "TypeScript",
        "Tailwind CSS",
        "Framer Motion",
        "Vercel",
        "Cloudflare",
        "Supabase",
        "Docker",
        "Zustand",
        "Zod",
        "Socket.IO",
        "WebSockets",
        "Figma",
        "Penpot",
        "Playwright",
        "Jest",
      ]}
    />
    </>
  );
}
